import en from './en.json'
import fr from './fr.json'

export const defaultLocale = 'en'
export const languages = {
    en: en,
    fr: fr
}